import React from 'react';
import { Box, Tabs, TabList, Tab, Heading } from "@chakra-ui/react";
import { Link, useLocation, useRoutes } from "react-router-dom";
import BillingInfo from './BillingInfo';
import SalesData from './artist/Sales';
import Transaction from './Transaction';
import { useAuth } from '../../hooks/useAuth';

const BillingAndPayments = () => {
  const location = useLocation();
  const { user } = useAuth();

  // Define paths for tabs based on user type
  const tabs = [
    
    { path: "/dashboard/billing/", label: "Purchases", element: <Transaction /> },
    ...(user.account_type === "artist"
      ? [{ path: "/dashboard/billing/sales", label: "Sales", element: <SalesData /> }]
      : []),
    { path: "/dashboard/billing/info", label: "Balances and payouts", element: <BillingInfo /> },

  ];

  // Determine active tab
  const activeIndex = tabs.findIndex((tab) => location.pathname === tab.path);

  // Use useRoutes to manage rendering the child routes
  const childRoutes = useRoutes(
    tabs.map((tab) => ({ path: tab.path.replace("/dashboard/billing/", ""), element: tab.element }))
  );

  return (
    <Box>
      <Heading mb={6} fontSize={{base:"xl",lg:"4xl"}} color="dark.900">
        Transactions and Payouts
      </Heading>

      {/* Tabs Navigation */}
      <Tabs isFitted variant="enclosed" index={activeIndex === -1 ? 0 : activeIndex}>
        <TabList overflow="auto">
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              as={Link}
              to={tab.path}
              _selected={{
                bg: 'dark.100',
                color: 'dark.900',
                fontWeight: 'bold',
                border: "1px solid",
                borderColor: "dark.900"
              }}
              _hover={{ color: 'dark.900', bg: "dark.500" }}
              color='primary.100'
              bg="secondary.100"
              borderRadius="sm"
              fontSize="sm"
              whiteSpace="nowrap"
              w="max-content"
              px={2}
              py={1}
              my={2} 
              mx={1}
              
            >
              {tab.label}
            </Tab>
          ))}
        </TabList>
      </Tabs>

      {/* ✅ Directly Render Child Components Instead of Outlet */}
      <Box mt={6}>
        {childRoutes}
      </Box>
    </Box>
  );
};

export default BillingAndPayments;